<template>
    <side-panel @close="close()" :loading="loading">
        <template slot="header">
            <h3 v-if="!bonusid" class="mt-0 clearfix">
                {{ $l10n.__('Ajouter une remise') }}
            </h3>
            <h3 v-else class="mt-0 clearfix">
                {{ $l10n.__('Editer une remise') }}
            </h3>
        </template>
        <template slot="content" class="flex-level">
            <el-form
                ref="bonusForm"
                label-position="top"
                :model="bonus"
                :inline-message="true"
                label-width="120px"
            >
                <el-form-item
                    :label="$t.__('common.labels.reference')"
                    prop="ref"
                    :error="errors.get('ref')"
                >
                    <el-input
                        data-bot="bonus-form--reference"
                        v-model="bonus.ref"
                        :value="bonus.ref"
                    />
                </el-form-item>
                <el-form-item
                    :label="$t.__('common.labels.name')"
                    prop="name"
                    :error="errors.get('name')"
                >
                    <el-input
                        data-bot="bonus-form--name"
                        v-model="bonus.name"
                        :value="bonus.name"
                    />
                </el-form-item>
                <el-form-item
                    :label="$t.__('common.labels.description')"
                    prop="name"
                    :error="errors.get('description')"
                >
                    <el-input
                        data-bot="bonus-form--description"
                        v-model="bonus.description"
                        type="textarea"
                        :rows="2"
                        :value="bonus.description"
                    />
                </el-form-item>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item
                            :label="$t.__('bonus.BonusForm.unit')"
                            prop="name"
                            :error="errors.get('unit')"
                        >
                            <el-select v-model="bonus.unit" data-bot="bonus-form--unit">
                                <el-option
                                    v-for="unit in units"
                                    :key="unit.id"
                                    :label="unit.value"
                                    :value="unit.id"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            :label="$t.__('common.labels.amount')"
                            prop="name"
                            :error="errors.get('amount')"
                        >
                            <input-number
                                data-bot="bonus-form--amount"
                                v-model="bonus.amount"
                                :value="bonus.amount"
                                :controls="false"
                                :precision="numberFormat.precision"
                                :separator-decimal="numberFormat.decimal"
                                :separator-thousand="numberFormat.thousand"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item
                    :label="$t.__('common.labels.accounting_code')"
                    prop="name"
                    :error="errors.get('acodeId')"
                >
                    <el-select
                        v-model="bonus.acodeId"
                        class="wp-6"
                        data-bot="bonus-form--account-code"
                    >
                        <el-option
                            :label="$t.__('bonus.BonusForm.default')"
                            :key="null"
                            :value="null"
                        />
                        <el-option
                            v-for="code in acodes"
                            :key="code.id"
                            :label="code.code + ' : ' + code.label"
                            :value="code.id"
                        />
                    </el-select>
                </el-form-item>
            </el-form>
        </template>

        <div slot="footer">
            <CompassButton :label="$t.__('common.actions.save')" @click.prevent="save" />
        </div>
    </side-panel>
</template>
<script>
import FormMixins from '../../mixins/FormMixins';
import InputNumber from 'vcomponents/utilities/InputNumber.vue';
import SidePanel from 'vcomponents/utilities/SidePanel.vue';

export default {
    mixins: [FormMixins],
    props: {
        bonusid: {
            required: false,
            default: false,
        },
        units: {
            type: Object,
            required: true,
        },
        acodes: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            bonus: {
                ref: '',
                name: '',
                description: '',
                amount: 0,
                unit: '',
                acodeId: null,
            },

            numberFormat: {
                precision: parseInt(App.numformat.precision),
                decimal: App.numformat.decimals,
                thousand: App.numformat.thousands,
            },

            loading: false,
        };
    },

    created() {
        if (this.bonusid) {
            this.loading = true;
            this.$ajax.get(
                '/rest/bonus/' + this.bonusid,
                {},
                (response) => {
                    response.amount = parseFloat(response.amount);
                    this.bonus = response;
                    if (this.bonus.acodeId != null) {
                        this.bonus.acodeId = parseInt(response.acodeId);
                    }
                    this.loading = false;
                },
                (error) => {
                    this.close();
                    Push.error(this.$l10n.__('Vous ne pouvez pas éditer cette remise'));
                    this.loading = false;
                },
            );
        }
    },

    methods: {
        save() {
            this.loading = true;
            if (this.bonusid) {
                this.$ajax.put(
                    `/rest/bonus/${this.bonusid}`,
                    {},
                    this.bonus,
                    (response) => {
                        this.close();
                        this.$trigger('listing:refresh');
                        Push.success(this.$l10n.__('Votre remise a été mise à jour'));
                    },
                    (error) => {
                        this.errors.setErrors(error.response.data.error.message);
                        this.loading = false;
                    },
                );
            } else {
                this.$ajax.post(
                    '/rest/bonus',
                    {},
                    this.bonus,
                    (data) => {
                        this.close();
                        this.$trigger('listing:refresh');
                        Push.success(this.$l10n.__('Votre remise a été créée'));
                        this.loading = false;
                    },
                    (error) => {
                        this.errors.setErrors(error.response.data.error.message);
                        this.loading = false;
                    },
                );
            }
        },

        close() {
            this.$emit('close');
        },
    },

    components: {
        'input-number': InputNumber,
        SidePanel,
    },
};
</script>
